
const $el = $(el);
const $video = $el.find('.box-video video');

$video[0].addEventListener("play", (event) => {
    const category = 'video_report';
    const action   = 'video_play';

    $document.trigger('remoteTrack', [category, action]);
});